// extracted by mini-css-extract-plugin
export var bodySections = "_69-8";
export var gray = "_69-7";
export var green = "_69-4";
export var iconContainer = "_69-9";
export var iconWidgetContainer = "_69-1";
export var phoneIcon = "_69-2";
export var red = "_69-5";
export var statusDot = "_69-3";
export var widgetContainer = "_69-0";
export var yellow = "_69-6";